






















































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { userModule } from "@/store/modules/user";
import RekonsiliasiObatCard from "@/pages/pemeriksaan_ranap/RekonsiliasiObatCard.vue";
import AlergiRekonsiliasiCard from "@/pages/pemeriksaan_ranap/AlergiRekonsiliasiCard.vue";
import SvcRekonsiliasiObat from "@/services/RekonsiliasiObat";
import SvcAlergiObat from "@/services/AlergiObat";
import ModalRekonsiliasiObatTransfer from "@/components/modal/ModalRekonsiliasiObatTransfer.vue";
import CardModalDaftarObat from "@/components/modal/CardModalDaftarObat.vue";

@Component({
  components: {
    RekonsiliasiObatCard,
    AlergiRekonsiliasiCard,
    ModalRekonsiliasiObatTransfer,
    CardModalDaftarObat
  }
})
export default class RekonsiliasiObatPage extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;

  loadingAlergi = false;
  tabRekon = 0;
  loadingRekon = false;
  loadingObat = false;
  showModalDaftarObat = false;
  listAlergi = [];
  rekonAdmisi = [];
  rekonTransfer = [];
  rekonPulang = [];
  daftarObat = [];
  modeAdmisi = "view";
  modeTransfer = "view";
  modePulang = "view";
  showModalTransfer = false;
  rekonsiliasiObatTransfer: object = {};

  get stateUser() {
    return userModule.user;
  }

  get currentRegister() {
    return RegisterKunjungan.register;
  }

  get headersAlergi() {
    return [
      { text: "Nama Alergi/ES Obat", value: "alergi" },
      { text: "Reaksi yang ditimbulkan", value: "reaksi" },
      { text: "Aksi", value: "aksi", sortable: false, align: "center" }
    ];
  }

  mounted() {
    this.getByRegister();
    this.getAlergiObat();
  }

  async getByRegister() {
    this.loadingRekon = true;
    await SvcRekonsiliasiObat.getByRegister(this.register)
      .then(resp => {
        if (resp.status === 1) {
          this.splitRekon(resp.data);
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      })
      .finally(() => {
        this.loadingRekon = false;
        this.modeAdmisi = "view";
        this.modeTransfer = "view";
        this.modePulang = "view";
      });
  }

  async getAlergiObat() {
    this.loadingAlergi = true;
    await SvcAlergiObat.getByRm(this.rm)
      .then(resp => {
        if (resp.status === 1) {
          this.listAlergi = resp.data;
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      })
      .finally(() => {
        this.loadingAlergi = false;
      });
  }

  splitRekon(val: any) {
    const data = Array.isArray(val) ? val : [];
    this.rekonAdmisi = data.filter(i => i?.category === "1") || [];
    this.rekonTransfer = data.filter(i => i?.category === "2") || [];
    this.rekonPulang = data.filter(i => i?.category === "3") || [];
  }

  tambahPulang() {
    this.modePulang = "save";
    const row = {
      id: null,
      register_id: this.register,
      pasien_rm: this.rm,
      category: "3",
      asal_unit_id: "",
      tujuan_unit_id: "",
      user_id: null,
      dokter_id: this.currentRegister.dokter.id,
      detail: []
    };
    this.rekonPulang.push(row);
  }
  tambahAdmisi() {
    this.modeAdmisi = "save";
    const row = {
      id: null,
      register_id: this.register,
      pasien_rm: this.rm,
      category: "1",
      asal_unit_id: "",
      tujuan_unit_id: "",
      user_id: null,
      dokter_id: this.currentRegister.dokter.id,
      detail: []
    };
    this.rekonAdmisi.push(row);
  }
  tambahTransfer() {
    const row = {
      id: null,
      register_id: this.register,
      pasien_rm: this.rm,
      category: "2",
      asal_unit_id: "",
      tujuan_unit_id: "",
      user_id: null,
      dokter_id: this.currentRegister.dokter.id,
      detail: []
    };
    this.rekonsiliasiObatTransfer = row;
    this.showModalTransfer = true;
  }

  reloadAll() {
    this.getByRegister();
    this.getAlergiObat();
  }

  getDaftarObat() {
    this.loadingObat = true;
    SvcRekonsiliasiObat.getDaftarObat(this.register)
      .then(resp => {
        if (resp.status === 1) {
          this.daftarObat = resp.data;
          this.showModalDaftarObat = true;
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      })
      .finally(() => {
        this.loadingObat = false;
      });
  }
  @Watch("tabRekon")
  onTabChange(val: number) {
    this.getByRegister();
  }
}
